import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Model } from "./Model";

export const ConfirmDeleteModal = ({ show, onClose, onConfirm, itemName, message, requireConfirmation = false, isLoading = false }) => {
    const [confirmInput, setConfirmInput] = useState("");

    useEffect(() => {
        if (show) setConfirmInput("");
    }, [show]);

    const isInputValid = !requireConfirmation || confirmInput === "delete";
    const isDeleteDisabled = !isInputValid || isLoading;

    return (
        <Model show={show} size="sm">
            <div className="p-6 text-center">
                <div className="w-16 h-16 rounded-full bg-red-50 text-red-500 flex items-center justify-center mx-auto mb-4 text-2xl">
                    <FontAwesomeIcon icon={faTrash} />
                </div>
                <h3 className="text-xl font-bold text-dark mb-2">Delete {itemName || "Item"}?</h3>
                <p className="text-gray text-sm mb-4">
                    {message || (
                        <span>
                            Are you sure you want to delete <span className="font-bold text-dark">"{itemName}"</span>? This action cannot be undone.
                        </span>
                    )}
                </p>

                {requireConfirmation && (
                    <div className="mb-6">
                        <label className="block text-xs text-gray-500 mb-2 uppercase font-bold">
                            Type <span className="text-dark select-all">delete</span> to confirm
                        </label>
                        <input
                            type="text"
                            value={confirmInput}
                            onChange={(e) => setConfirmInput(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-center focus:ring-2 focus:ring-red-500/20 focus:border-red-500 outline-none transition-all placeholder:text-gray-300"
                            placeholder="delete"
                        />
                    </div>
                )}

                <div className="flex gap-3 justify-center">
                    <button
                        onClick={onClose}
                        disabled={isLoading}
                        className="px-5 py-2 rounded-lg bg-white border border-lightGray text-dark font-medium hover:bg-gray-50 transition-colors disabled:opacity-50"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isDeleteDisabled}
                        className={`px-5 py-2 rounded-lg font-medium shadow-md transition-all flex items-center gap-2 bg-red-500 text-white hover:bg-red-600
                            ${isDeleteDisabled
                                ? "opacity-50 cursor-not-allowed"
                                : "hover:shadow-lg hover:-translate-y-0.5"
                            }
                        `}
                    >
                        {isLoading && (
                            <div className="w-4 h-4 border-2 border-white/50 border-t-white rounded-full animate-spin"></div>
                        )}
                        {isLoading ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </div>
        </Model>
    );
};
